export enum PublicAvailability {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
}
